var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v("测试卡槽数据:")]),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"date","label":"日期"}}),_c('el-table-column',{attrs:{"prop":"name","label":"姓名"}}),_c('el-table-column',{attrs:{"prop":"address","label":"地址"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }